import { render } from "./JobHistoryModal.vue?vue&type=template&id=be01c74a&ts=true"
import script from "./JobHistoryModal.vue?vue&type=script&lang=ts"
export * from "./JobHistoryModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__